import { Log, UserManager } from 'oidc-client'
import { Config } from '../configurations/config'

export class AuthService {
	userManager = new UserManager()

	constructor() {
		const settings = {
			authority: Config.tossAuth,
			client_id: 'C06EB280-01D6-420D-B811-CBC29DCD609C',
			redirect_uri: 'http://localhost:3000/signin',
			response_type: 'token',
			scope: 'TOSSAPI',
			post_logout_redirect_uri: 'http://localhost:3000/signin',
		}
		this.userManager = new UserManager(settings)

		Log.logger = console
		Log.level = Log.INFO
	}
	getUser = async () => {
		window.location.hash = decodeURIComponent(window.location.hash)
		return this.userManager.getUser()
	}
	login = async () => {
		return this.userManager.signinRedirect()
	}
	signinRedirectCallback = async () => {
		return this.userManager.signinRedirectCallback()
	}
	renewToken = async () => {
		return this.userManager.signinSilent()
	}
	logout = async () => {
		return this.userManager.signoutRedirect()
	}
}
